import Nullstack from 'nullstack';
export default function IconChairDirector({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-chair-director",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6 21l12 -9"
  }), "   ", Nullstack.element("path", {
    d: "M6 12l12 9"
  }), "   ", Nullstack.element("path", {
    d: "M5 12h14"
  }), "   ", Nullstack.element("path", {
    d: "M6 3v9"
  }), "   ", Nullstack.element("path", {
    d: "M18 3v9"
  }), "   ", Nullstack.element("path", {
    d: "M6 8h12"
  }), "   ", Nullstack.element("path", {
    d: "M6 5h12"
  }), " ");
}